import { notification, Switch, Tabs } from 'antd';
import { AuthContext } from 'components/Auth/Auth';
import ModalControllerNV from 'components/ModalControllerNV';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import _, { noop, isNil, isArray } from 'lodash';
import React, { useState, useContext } from 'react';
import { useQuery } from 'react-query';
import { getProcTaskInit } from 'services/workflow';
import TaskModal from './TaskModal';
import { PropThirdPartyResponse } from 'services/proposal';
import { FormInstance } from 'antd/lib';
import {
  ToolOutlined
} from '@ant-design/icons';
import { request } from 'utils/request';
import { parseQueryParams } from 'utils/parseQueryParams';
import { API_URLS } from 'utils/config';
import { customDataPrepareForApiCallSFS, prepareObjectForApiCall } from 'utils/utilsSFS';
import Notifications from 'components/theme_components/Notifications';

export type TasksListPopoverProps = {
  tptype?: string;
  countcode?: string;
  tpid?: number;
  formTP?: FormInstance;
  mgid?: number;
  entityName: string;
  entityReference?: string;
  entityId: number;
  title?: string;
  subentity?: string;
  subentityid?: number;
  onSuccess?: any;
  children?: React.ReactChild;
  dataCtr?: Array<PropThirdPartyResponse>;
  dataInput?: any;
  dataList?: any;
  action?: string;
  funcode: string;
  entityList?: Array<{ entityId: number }>;
  status?: string;
  statusdate?: string;
  requestedamount?: number;
  currcode?: string;
  parcode?: string;
  parvalue?: string;
  parvalueparent?: string;
  clientName?: string;
  ctrid?: number;
  refetchProp?: any;
  onClose?: any;
  prcode?: string;
  wizardsteps?: boolean;
  refetch: () => void;
  width?: number;
  defaultChecked: boolean
};



const TasksSwitchButtonSFS = ({
  refetch,
  dataCtr,
  tptype,
  countcode,
  formTP,
  mgid,
  entityId,
  entityName,
  title,
  subentity,
  subentityid,
  entityReference,
  tpid,
  onSuccess = noop,
  dataInput,
  action,
  funcode,
  entityList,
  status,
  statusdate,
  requestedamount,
  currcode,
  parcode,
  parvalue,
  parvalueparent,
  clientName,
  ctrid,
  refetchProp,
  onClose,
  prcode,
  children,
  wizardsteps,
  width,
  dataList,
  defaultChecked,
  ...otherProps
}: TasksListPopoverProps) => {
  const { TabPane } = Tabs;
  const [visiblePopover, setVisiblePopover] = useState(false);
  const closePopover = () => setVisiblePopover(false);
  const { getComponentLabel } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);


  const [successful, setSuccessful] = useState<boolean>(false);
  const [isFinish, setIsFinish] = useState<boolean>(false);

  const [additionalAttributeList, setadditionalAttributeList] = useState<any>();
  const [load, setload] = useState(false);


  const [value, setValue] = useState(defaultChecked);

  const prepareObjectForApiCall = (val: boolean) => {
    return {
      siloid: dataInput.siloid,
      silostatus: val == true ? 'ACTIVE' : 'INACTIVE'
    }
  }

  const {
    data = [],
    isLoading,
    isError,

  } = useQuery(
    [
      'getProcTaskInit',
      { entityId, entityName, funcode, action, prcode },
      refetchProp,
    ],
    () =>
      getProcTaskInit({
        entity: entityName,
        entityid: entityId,
        funcode: funcode,
        action: action ?? '',
        prcode: prcode ?? '',
      }).then((res) => res.list || [])
  );



  const handleOk = (val: boolean) => {

    debugger;
    let task = data[0];
    const [url, paramsString] = task.serviceurl
      ? task.serviceurl.split('?')
      : ''.split('?');
    setload(true);
    request
      .post(`${API_URLS.WORKFLOW}/api/${url}`, {
        ...parseQueryParams(paramsString),
        entityId,
        entity: entityName,
        taskid: task?.taskid,
        subentity: task?.subentity,
        subentityid: task?.subentityid,
        objectreference: entityReference,
        entityAddAttributList: additionalAttributeList ?? [],
        ...prepareObjectForApiCall(val),
      })
      .then((res) => {
        if (res.success) {
          // notification.success({ message: res.message });
          Notifications({
            status: 'success',
            message: res.message,
            description: res.description,
            duration: 2,
            placement: 'topRight',
          });
          setIsFinish(true);
          // refetchChecks();
          // refetchConsequences();
          onSuccess();
          setload(false);
          setValue(!value)
          refetch && refetch();
        } else {
          setload(false);
          return Promise.reject(res);
        }
      })
      .catch((res) => {
        setload(false);

        try {
          let errormsg: any;
          if (res.message && !isNil(res.message) && res.message !== '') {
            let listError = JSON.parse(res.message);
            if (isArray(listError)) {
              errormsg = React.createElement(
                'table',
                { className: 'styled-table' },
                null,
                React.createElement(
                  'thead',

                  null,
                  React.createElement(
                    'tr',
                    { className: 'active-row' },
                    React.createElement(
                      'th',

                      null,
                      'Code'
                    ),
                    React.createElement(
                      'th',

                      null,
                      'Message'
                    )
                  )
                ),

                listError.map((error: any) => {
                  return React.createElement(
                    'tr',
                    { className: 'active-row' },
                    React.createElement(
                      'td',
                      { style: { fontWeight: '700' } },
                      error.ccode
                    ),
                    React.createElement(
                      'td',

                      null,
                      error.message
                    )
                  );
                })
              );

              notification.error({
                description: errormsg,
                message: React.createElement(
                  'span',
                  { style: { fontWeight: '700', color: '#660000' } },
                  'Functional Controls'
                ),
                className: 'error417',
                style: {
                  width: 400,
                  padding: '9px 12px 1px 12px',
                  marginLeft: 0,
                },
              });
            } else {
              errormsg = listError;
              notification.error({
                message: errormsg,
              });
            }
          }

          return Promise.reject(res);
        } catch (Exception) {
          notification.error({ message: res.message });
        }
        setload(false);
      });


    //;
  };
  return (
    data?.length > 0 && (
      <div onClick={(e) => e.stopPropagation()}>

        <Switch
          value={value}
          // onChange={onChange}
          onChange={(e) => {
            handleOk(e)
          }}
          green-color
          className="color-green floatRight  custom-switch "
          loading={load}
          style={{marginLeft: "28px"}}
        />

      </div >
    )
  );
};

export default TasksSwitchButtonSFS;
